<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Tesorería</li>
      </ol>
    </nav>

    <menu-grid :sections="sections"></menu-grid>
  </div>
</template>

<script>
import MenuGrid from "@components/menu-grid/menu-grid";

export default {
  name: "treasury",
  components: { MenuGrid },
  data: () => ({
    sections: [
      {
        name: "Dispersiones",
        menuItems: [
          {
            route: '/treasury/dispersions',
            title: 'Dispersión General'
          },
          {
            route: '/recurrent-commission',
            title: 'Comisiones recurrentes',
          },
          {
            route: '/treasury/withdrawals/rg/done',
            title: 'Consulta RedGirasol'
          },
          {
            route: '/treasury/withdrawals/investor/done',
            title: 'Consulta Inversionista'
          },
          {
            route: '/treasury/withdrawals/supplier/done',
            title: 'Consulta Instaladores'
          },
          {
            route: '/treasury/transfer-to-beneficiaries',
            title: 'Ejecución de Beneficiarios'
          }
        ]
      },
      {
        name: "Domiciliaciones",
        menuItems: [
          {
            route: '/direct-billing',
            title: 'General'
          }
        ]
      },
      {
        name: "Verificaciones",
        menuItems: [
          {
            route: '/bankAccounts/notVerified',
            title: 'Cuentas bancarias Proveedores'
          }
        ]
      },
      {
        name: "Mercado secundario",
        menuItems: [
          {
            route: '/secondary-market',
            title: 'Mercado secundario'
          },
          {
            route: '/treasury/loan-management',
            title: 'Gestión de Créditos'
          }
        ]
      },
      {
        name: "Transacciones",
        menuItems: [
          {
            route: '/treasury/irregular-trx',
            title: 'Transacciones irregulares'
          },
          {
            route: '/treasury/manual-trx',
            title: 'Transacciones manuales'
          }
        ]
      }
    ]
  })
}
</script>

<style scoped>

</style>
